import crypto from "crypto"; // should have webcrypto.getRandomValues defined
import { v4 as uuidV4 } from "uuid";

export const generateUniqueID = () => {
  if (typeof global.crypto !== "object") {
    global.crypto = crypto;
  }

  if (typeof global.crypto.getRandomValues !== "function") {
    global.crypto.getRandomValues = getRandomValues;
  }
  return uuidV4();
};

function getRandomValues(array) {
  return crypto.webcrypto.getRandomValues(array);
}
